import styled from "styled-components";

const Column = styled.div``;

export { Column };
